import React from 'react';
import { IconButton } from '@noths/polaris-design-system-core-components';

import type { FavouriteButtonProps } from './FavouriteButton.types';

export const FavouriteButton = ({
  active = false,
  activeIcon = 'favoriteFull',
  inactiveIcon = 'favoriteEmpty',
  label = 'Favourite',
  onClick,
  size = 'lg',
}: FavouriteButtonProps) => {
  const icon = active ? activeIcon : inactiveIcon;

  return (
    <IconButton
      aria-label={label}
      aria-pressed={active}
      compact={size === 'sm'}
      /* Duplicates `icon` deliberately. IconButton renders the svg itself and passes it
         nothing we control, so the button is the only element we can mark, and Jest runs
         through ts-jest with no styled-components transform, leaving svg path data as the
         only alternative seam. Removing this blindly will silently weaken the specs. */
      data-icon={icon}
      icon={icon}
      onClick={onClick}
    />
  );
};

FavouriteButton.displayName = 'FavouriteButton';
